import PropTypes from 'prop-types'
import { Button, ConfigProvider, Flex, Form } from 'antd'
import { useIntl } from 'react-intl'
import NewPasswordFields from './NewPasswordFields'
import { FORM_THEME } from './theme'

// First sign-in with a temporary password: Cognito requires a new one before
// it hands out tokens.
const NewPasswordForm = ({ busy, onSubmit, onBack }) => {
  const intl = useIntl()

  return (
    <ConfigProvider theme={FORM_THEME}>
      <Form
        id="new-password-form"
        name="new-password-form"
        layout="vertical"
        requiredMark={false}
        disabled={busy}
        onFinish={(values) => onSubmit(values.new_password)}
      >
        <NewPasswordFields autoFocus={true} />
        <Flex vertical={true} gap="small">
          <Button type="primary" htmlType="submit" size="large" block loading={busy} data-testid="challenge-submit">
            {intl.formatMessage({ id: 'auth.setPasswordButton' })}
          </Button>
          <Flex justify="center">
            <Button type="link" onClick={onBack} data-testid="back-to-sign-in">
              {intl.formatMessage({ id: 'auth.backToSignIn' })}
            </Button>
          </Flex>
        </Flex>
      </Form>
    </ConfigProvider>
  )
}

NewPasswordForm.propTypes = {
  busy: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default NewPasswordForm
